var map = {
	"./classic.png": "74d1",
	"./delete-element-button.png": "7030",
	"./edit-element-button.png": "92ad",
	"./hoodie.png": "aab5",
	"./jacket-back-sub-raglan-classic.png": "b42c",
	"./jacket-back-sub-raglan-hood.png": "faef",
	"./jacket-back-sub-raglan-zipper.png": "96a5",
	"./jacket-back-sub-setIn-classic.png": "97b6",
	"./jacket-back-sub-setIn-hood.png": "ad8d",
	"./jacket-back-sub-setIn-zipper.png": "3a70",
	"./jacket-front-sub-raglan-classic.png": "7389",
	"./jacket-front-sub-raglan-hood.png": "6568",
	"./jacket-front-sub-raglan-zipper.png": "de36",
	"./jacket-front-sub-setIn-classic.png": "65df",
	"./jacket-front-sub-setIn-hood.png": "e00a",
	"./jacket-front-sub-setIn-zipper.png": "baba",
	"./jacket-left-sub-raglan-classic.png": "4147",
	"./jacket-left-sub-raglan-hood.png": "cd2b",
	"./jacket-left-sub-raglan-zipper.png": "a080",
	"./jacket-left-sub-setIn-classic.png": "2258",
	"./jacket-left-sub-setIn-hood.png": "f69e",
	"./jacket-left-sub-setIn-zipper.png": "3019",
	"./jacket-right-sub-raglan-classic.png": "09cb",
	"./jacket-right-sub-raglan-hood.png": "3fbc",
	"./jacket-right-sub-raglan-zipper.png": "b00c",
	"./jacket-right-sub-setIn-classic.png": "d675",
	"./jacket-right-sub-setIn-hood.png": "cc50",
	"./jacket-right-sub-setIn-zipper.png": "cc08",
	"./jacket_back.png": "f9f0",
	"./jacket_front.png": "f5f5",
	"./jacket_left.png": "18c2",
	"./jacket_right.png": "4129",
	"./logo.png": "9d64",
	"./resize-element-button.png": "41c0",
	"./rotate-element-button.png": "4f81",
	"./zipper-hood.png": "cfc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";